import { defineStore } from "pinia";
import { StateTree, _GettersTree, _ActionsTree } from "pinia";

// Interfaz del estado
interface ContributionState extends StateTree {
  selectedContribution: Record<string, any> | null; // Contribución seleccionada
}

// Interfaz de getters
interface ContributionGetters extends _GettersTree<ContributionState> {
  getSelectedContribution: (
    state: ContributionState
  ) => Record<string, any> | null;
}

// Interfaz de acciones
interface ContributionActions extends _ActionsTree {
  setSelectedContribution(contribution: Record<string, any>): void;
  clearSelectedContribution(): void;
}

// Definición del store
export const useContributionStore = defineStore<
  "contribution",
  ContributionState,
  ContributionGetters,
  ContributionActions
>("contribution", {
  // Estado inicial
  state: () => ({
    selectedContribution: null,
  }),

  // Getters
  getters: {
    // Obtener la contribución seleccionada
    getSelectedContribution: (state) => state.selectedContribution,
  },

  // Acciones
  actions: {
    // Establecer la contribución seleccionada
    setSelectedContribution(contribution) {
      this.selectedContribution = contribution;
    },

    // Limpiar la contribución seleccionada
    clearSelectedContribution() {
      this.selectedContribution = null;
    },
  },

  // Persistencia opcional para mantener la contribución seleccionada en el almacenamiento local
  persist: {
    storage: localStorage,
    pick: ["selectedContribution"],
  },
});
